import React, {useEffect, useState} from "react";
import {useHistory} from "react-router-dom";
import './sections.scss'
import {FestivalData} from "../../Festival/FestivalServices";
import SwiperId from "react-id-swiper";
import {ReportData} from "../../Report/ReportServices";
import SimpleLineIcon from "react-simple-line-icons";
import {ConvertToJalali, FactorData} from "../../StoreDetail/StoreDetailServices";
import Rodal from "rodal";
import "../../Report/Report.scss";
import {ConvertTMonthName} from "../../../Services";
import moment from "moment-jalaali";
const MyInvoiceList = ({item}) =>{

    //vars
    const history = useHistory();
    const [invo,setInvo] = useState([])
    const [factor, setFactor] = useState({})
    const [showModal, setShowModal] = useState(false);


    const imageParams = {
        slidesPerView: 2,
        spaceBetween: 20,
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        }
    }

    const ConvertToJalaliSplited = (date) =>{
        let month = ConvertTMonthName(moment.utc(date.split('+')[0]).format('jMM'));
        let year = moment.utc(date.split('+')[0]).format('jYYYY');
        let day = moment.utc(date.split('+')[0]).format('jDD');
        return day+" "+month+""+year
    }


    const   HistoryCard = ({item,getFactor}) =>{

        const [load,setLoad] = useState(false)

        return(
            <>
            <div  className="storeDetail-history-item" style={{margin:'26px 16px'}} onClick={()=>{
                setLoad(true);
                getFactor(item.uid);
            }}>
                <div className="storeDetail-history-item-price">
                    <i className="fa fa-angle-left"></i>
                    <span>ریال</span>
                    <span> {numberWithCommas(item.amount)}</span>
                </div>
                <div className="storeDetail-history-item-info">
                    <div className="storeDetail-history-item-info-detail">
                        <span className="detail_date">{item.merchant && item.merchant.name}</span>
                        <span className="detail_factor_number">{ConvertToJalaliSplited(item.created)}</span>
                    </div>
                    <div className="storeDetail-history-item-info-icon">
                        {load?<i className="fa fa-spinner fa-spin" style={{fontSize:28}}></i>:<img style={{borderRadius:5,width:30,height:30,alignItem:"flex-start"}} src={item.merchant && item.merchant.thumbnail} alt=""/>}
                    </div>
                </div>
            </div>
                </>
        )
    }



    const getFactorDetail = async (id) => {
        try {
            const factor = await FactorData(id);
            setFactor(factor.data);
            setShowModal(true)
            return true;
        } catch (e) {
            // console.log(e)
            return false;
        }
    }

    function numberSubWithCommas(x) {
        // convert To toman
        // x= (x/10).toFixed(0)
        //add commas

        if (typeof x==="string" && x) {
            let num = x.split(".");
            return x ? num[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0;
        } else {
            return "0"
        }

    }

    const numberWithCommas = (x) => {
        if (x === 0) {
            return 0
        }
        return x ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0;
    }



    const getReport = async () => {
        try {
            const reportData = await ReportData();
            // console.log("re", reportData)
            let invoceData = reportData.data.results.splice(0,5)
            setInvo(invoceData)
        } catch (e) {
            // console.log(e)
        }
    }


    useEffect(()=>{
        getReport()
    },[])



    return(
        <div className="MyInvoiceList-container">
            <Rodal animation={"zoom"} visible={showModal} onClose={() => setShowModal(false)}>

                <div className="factor-header">
                    <div className="factor-header-item left">
                        <span className="factor-header-item-title">تاریخ</span>
                        {factor.created ?
                            <span className="factor-header-item-val">{ConvertToJalali(factor.created)}</span> : null}
                    </div>
                    <div className="factor-header-item right">
                        <span className="factor-header-item-title">شماره فاکتور</span>
                        {factor.uid ? <span className="factor-header-item-val">{factor.uid}</span> : null}
                    </div>
                </div>

                <div className="factor-table">
                    <table>
                        <thead>
                        <tr>
                            <th className="product-table-head">جمع کل</th>
                            {/*<th className="product-table-head">تخفیف</th>*/}
                            <th className="product-table-head">تعداد</th>
                            <th className="product-table-head product-table-head-name">نام کالا</th>
                            <th className="product-table-head product-table-head-name">تصویر</th>
                        </tr>
                        </thead>
                        <tbody>
                        {factor.products && factor.products.map(product => {
                            return (
                                <tr key={product.uid}>
                                    <td className="product-price">{numberWithCommas(product.amount)}</td>
                                    {/*<td className="product-count">{numberWithCommas(product.per_discount)}</td>*/}
                                    <td className="product-count">{product.quantity}</td>
                                    <td className="product-name">{product.name}</td>
                                    <td className="product-name">
                                        {product.product?<img
                                            src={product.product && product.product.image ? product.product.image : "/other/skeleton/product.jpg"}
                                            alt=""/>:null}
                                    </td>
                                </tr>
                            )
                        })
                        }
                        </tbody>
                    </table>

                    <div className="factor-table-total-row customer_discount-row">
                        <div className="factor-table-total--price customer_discount-val">
                            <span>ریال</span>
                            {<span>{numberWithCommas(factor.discount_amount)}</span>}
                        </div>
                        <span className="customer_discount"> : تخفیف  </span>
                    </div>

                    <div className="factor-table-total-row">
                        <div className="factor-table-total--price">
                            <span>ریال</span>
                            {factor.payable_amount ? <span>{numberWithCommas(factor.payable_amount)}</span> : null}
                        </div>
                        <span> : جمع کل  </span>
                    </div>
                </div>
            </Rodal>
            {/*{item.title?<div className="storeDetail-reward-titre">*/}
            {/*    {item.title}*/}
            {/*</div>:null}*/}

            {item.title?<div className="section-title"><span>{item.title}</span></div>:null}

            {invo.slice(0,2).map(item => {
            return (
            // <InvCard item={item} getFactorDetail={getFactorDetail}/>
            <HistoryCard key={item.uid} item={item} getFactor={getFactorDetail}/>
            )})
        }
            <div className="see-more-invoice">
                <div className="see-more-invoice-btn" onClick={()=>{
                    history.push("/reward")
                }}>
                    <i className="fa fa-angle-left"></i>
                    <span>مشاهده همه صورت حساب ها</span>
                </div>
            </div>
        </div>
    )
}

export {MyInvoiceList}
